import { Component, inject } from '@angular/core';
import { PageComponent, Redirection } from '@tytapp/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-communication-preference',
  templateUrl: './communication-preference.component.html',
  styleUrls: ['./communication-preference.component.scss']
})
export class CommunicationPreferenceComponent extends PageComponent {
  private redirection = inject(Redirection);
  
  async init() {
    this.redirection.go(`${environment.urls.app}/settings/newsletters`);
  }
}
